import React from 'react';
import PropTypes from 'prop-types';

import './google-play-button.less';

const GooglePlayButton = ({ url }) => (
  <a className="google-play-button" target="_blank" href={url}>
    <img
      src="//www.nerdwallet.com/cdn/DIT/google-play-button.png"
      alt="Get it on Google Play"
    />
  </a>
);

GooglePlayButton.propTypes = {
  url: PropTypes.string.isRequired,
};

GooglePlayButton.displayName = 'GooglePlayButton';

export default GooglePlayButton;
